import { RouteObject } from "react-router-dom";
import SettingsLanding from "./components/settingsLanding/settingsLanding";


export interface SettingsRoute extends Omit<RouteObject, 'children'> {
  auth?: boolean;
  children?: SettingsRoute[];
}
export const cxSettingsRoutes: SettingsRoute[] = [
  {
    path: "/cx/settings",
    element: <SettingsLanding />,
  },
];

